var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 204 207",
    style: {
      enableBackground: "new 0 0 204 207"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#FC1D1D;}\n\t.st2{opacity:0.206;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    transform: "translate(-112 -285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584",
    transform: "translate(112 285)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-2",
    transform: "translate(144 285)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-3",
    transform: "translate(176 285)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-4",
    transform: "translate(208 285)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-5",
    transform: "translate(240 285)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-6",
    transform: "translate(272 285)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-7",
    transform: "translate(304 285)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-8",
    transform: "translate(112 317)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-9",
    transform: "translate(144 317)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-10",
    transform: "translate(176 317)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-11",
    transform: "translate(208 317)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-12",
    transform: "translate(240 317)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-13",
    transform: "translate(272 317)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-14",
    transform: "translate(304 317)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-15",
    transform: "translate(112 349)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-16",
    transform: "translate(144 349)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-17",
    transform: "translate(176 349)",
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-18",
    transform: "translate(208 349)",
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-19",
    transform: "translate(240 349)",
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-20",
    transform: "translate(272 349)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-21",
    transform: "translate(304 349)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-22",
    transform: "translate(112 381)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-23",
    transform: "translate(144 381)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-24",
    transform: "translate(176 381)",
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-25",
    transform: "translate(208 381)",
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-26",
    transform: "translate(240 381)",
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-27",
    transform: "translate(272 381)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-28",
    transform: "translate(304 381)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-29",
    transform: "translate(112 413)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-30",
    transform: "translate(144 413)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-31",
    transform: "translate(176 413)",
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-32",
    transform: "translate(208 413)",
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-33",
    transform: "translate(240 413)",
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-34",
    transform: "translate(272 413)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-35",
    transform: "translate(304 413)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-36",
    transform: "translate(112 445)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-37",
    transform: "translate(144 445)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-38",
    transform: "translate(176 445)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-39",
    transform: "translate(208 445)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-40",
    transform: "translate(240 445)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-41",
    transform: "translate(272 445)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_584-42",
    transform: "translate(304 445)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_588",
    transform: "translate(112 480)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_589",
    transform: "translate(144 480)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_590",
    transform: "translate(176 480)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_591",
    transform: "translate(208 480)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_592",
    transform: "translate(240 480)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_593",
    transform: "translate(272 480)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_594",
    transform: "translate(304 480)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 11
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.974f2925b1da7eaca7156e2dcfb4ffe7.svg";
export { ForwardRef as ReactComponent };